import { getEllipsisTxt } from '@/shared/lib'
import { ConfigStore } from '@/shared/model/store'
import { IPublicGateway } from '@/shared/model/store/config-store'
import { Badge, Button, Input, Switch } from '@/shared/ui'
import SelectComponent from '@/shared/ui/select-component'
import { TrashIcon } from 'lucide-react'
import React from 'react'

const DEFAULT_GATEWAY_UNIT = {
    type: 'filebase',
    url: '',
    secret: ''
  }

const PublicIpfsGateway = () => {
  const { localGateway, publicGateways, setPublicGateways } = ConfigStore()
  const [selectedGateway, setSelectedGateway] = React.useState<IPublicGateway>(DEFAULT_GATEWAY_UNIT)

  const handleSelectGateway = (type: string) => {
    setSelectedGateway((prev: IPublicGateway) => ({
      ...prev,
      type,
    }))
  }

  const handleSecretGateway = (e: any) => {
    setSelectedGateway((prev) => ({
      ...prev,
      secret: e.target.value
    }))
  }

  const handleRemoveGateway = (secret: string) => {
    setPublicGateways({
      ...publicGateways,
      gateways: publicGateways.gateways.filter((el) => el.secret !== secret)
    })
  }

  const handleAddGateway = () => {
    setPublicGateways({
      ...publicGateways,
      gateways: [...publicGateways.gateways, selectedGateway]
    })
    setSelectedGateway(DEFAULT_GATEWAY_UNIT as IPublicGateway)
  }
  return (
    <div>
        <div className='flex items-center justify-between border-b-2 pb-2 font-bold'>
                        <div className='flex items-end gap-4'>
                            <span>Public IPFS gateways settings</span>
                        </div>
                        <span>
                            {publicGateways.enable && <Badge variant={'success'}>Enabled</Badge>}
                            {!publicGateways.enable && <Badge variant={'secondary'}>Disabled</Badge>}
                        </span>
                    </div>
                    {!localGateway.enable && <div className='mt-2 flex items-center justify-between border-2 border-red-600 bg-red-100 p-4 text-red-800 rounded-md' >
                        Запустите локальную IPFS ноду, без нее использование своих gateway не будет доступно
                    </div>}
                    <div className='mt-2 flex items-center justify-between'>
                        <div className='flex items-center gap-4'>
                            <span>Enable public IPFS gateways</span>
                            <div className='flex items-center gap-1'></div>
                        </div>
                        <Switch
                            checked={publicGateways?.enable}
                            onCheckedChange={state => setPublicGateways({ ...publicGateways, enable: state })}
                        />
                    </div>
                    <div className='flex flex-col gap-4 mt-5'>
                        {publicGateways.gateways.map((el, index) => (
                            <div className='grid w-full grid-cols-3' key={el.secret}>
                                <div>{el.type}</div>
                                <div className='text-sm text-[grey]'>{getEllipsisTxt(el.secret, 8, '***********')}</div>
                                <div className='flex justify-end items-center gap-4'>
                                    {index === 0 ? <Badge>Default</Badge> : <Button variant={'secondary'} size={'sm'}>Set default</Button>}
                                    <Button onClick={() => handleRemoveGateway(el.secret)} variant={'outline_destructive'} size={'sm'}><TrashIcon /></Button>
                                </div>
                            </div>
                        ))}
                        <div className='grid w-full grid-cols-3'>
                            <div>
                                <div className='w-[80%]'>
                                    <SelectComponent options={[{value: 'filebase', label: 'Filebase'}]} onChange={(state) => handleSelectGateway(state)} value='filebase'/>
                                </div>
                            </div>
                            <div>
                                <Input placeholder='Enter secret key' onChange={handleSecretGateway} value={selectedGateway.secret}/>
                            </div>
                            <div className='flex justify-end'>
                                <Button onClick={handleAddGateway} variant={'outline_success'}>Save</Button>
                            </div>
                        </div>
                    </div>
    </div>
  )
}

export default PublicIpfsGateway